import { GridAction } from '@eforall/dashboard';
import { CourseEnrollment } from '../enrollments-view.part';

export function getActions() {

	const actions: GridAction<CourseEnrollment>[] = [];

	return actions;
}